module.exports = __webpack_public_path__ + "img/3.8b3fe1a1.jpg";